console.info("Refresh.js v.1.0.0");

function runRefresh() {
  initMobileMenu();
  createPageLoadListener();
  createSortSelectListener();
  resizeFeaturedAssets();
  addBrowserHistoryApiEvents();
}

function addBrowserHistoryApiEvents() {
  // First, create a function to dispatch a custom event (e.g., "urlchange") when the URL changes
  function dispatchUrlChangeEvent() {
    window.dispatchEvent(new CustomEvent("urlchange"));
  }

  // Override pushState and replaceState to dispatch the custom event
  (function (history) {
    var pushState = history.pushState;
    var replaceState = history.replaceState;

    history.pushState = function (state) {
      // Call the original pushState function
      var result = pushState.apply(history, arguments);
      // Dispatch the custom event
      dispatchUrlChangeEvent();
      return result;
    };

    history.replaceState = function (state) {
      // Call the original replaceState function
      var result = replaceState.apply(history, arguments);
      // Dispatch the custom event
      dispatchUrlChangeEvent();
      return result;
    };
  })(window.history);
}

function resizeFeaturedAssets() {
  var featuredAssetsMedia = Array.from(
    document.querySelectorAll(".featured-asset .media"),
  );

  // featuredAssetsMedia.forEach((node) => {
  //   new ResizeObserver(() => {
  //     var ratio = 671 / 447;
  //     var width = node.offsetWidth;
  //     var height = width * ratio;
  //     node.style.height = `${height}px`;
  //   }).observe(node);
  // });
}

function createImageLoadListeners() {
  var images = Array.from(document.querySelectorAll("img"));
  images.forEach((img) => {
    if (img.hasLoadListener) return;
    img.hasLoadListener = true;
    if (window.caches.match(img.src)) return img.setAttribute("loaded", "true");
    img.addEventListener("load", () => img.setAttribute("loaded", "true"));
  });
  setInterval(createImageLoadListeners, 100);
}

function createPageLoadListener() {
  window.addEventListener("load", document.body.classList.add("loaded"));
}

function initMobileMenu() {
  var menuBtn = document.querySelector(".mobile-nav .menu-bar .menu-btn");
  if (menuBtn) menuBtn.onclick = toggleMobileMenu;
}

function showMobileMenu() {
  var menu = document.querySelector(".mobile-nav .menu");
  menu.classList.add("expanded");
}

function hideMobileMenu() {
  var menu = document.querySelector(".mobile-nav .menu");
  menu.classList.remove("expanded");
}

function toggleMobileMenu() {
  var menu = document.querySelector(".mobile-nav .menu");
  menu.classList.toggle("expanded");
}

function createSortSelectListener() {
  var select = document.querySelector("select.sort-by");
  if (!select) return;
  var displayText = select.parentNode.querySelector(".display-text");
  var value = getQueryParam("sort_by");
  var values = Array.from(select.querySelectorAll("option")).map(
    (o) => o.value,
  );
  if (values.includes(value)) select.value = value;
  setDisplayText();
  select.addEventListener("change", () => {
    setDisplayText();
    window.location = setQueryParm("sort_by", select.value);
  });
  function setDisplayText() {
    var text = select.options[select.selectedIndex].innerHTML;
    displayText.innerHTML = text + " +";
  }
}

function setQueryParm(key, value) {
  var uri = window.location.href;
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  return uri.match(re)
    ? uri.replace(re, "$1" + key + "=" + value + "$2")
    : uri + separator + key + "=" + value;
}

function getQueryParam(key) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (decodeURIComponent(pair[0]) == key) {
      return decodeURIComponent(pair[1]);
    }
  }
}

function createReccomendedProducts() {
  var container = document.querySelector(".recommended-products-container");
  var parent = document.querySelector(".products.recommended-products");
  var section = document.querySelector(
    "#shopify-section-product-recommendations",
  );
  var products = Array.from(section.querySelectorAll(".product-block"));
  if (products.length < 1) return;
  var productNode = (product) => {
    var price = product.querySelector(".price .theme-money ")?.innerText;
    var href = product
      .querySelector(".grid-product__link ")
      .getAttribute("href");
    var src =
      product.querySelector(".grid-product__image")?.getAttribute("data-src") ||
      product.querySelector("img.first")?.getAttribute("src");
    var alt =
      product.querySelector(".grid-product__image")?.getAttribute("alt") ||
      product.querySelector("img.first")?.getAttribute("alt");
    var titleNode = product.querySelector(".grid-product__title");
    var shouldShowInText = titleNode.getAttribute("data-showintext") !== "true";
    var title = titleNode.innerText
      .split("")
      .reverse()
      .join("")
      .replace("-", shouldShowInText ? "ni" : "")
      .split("")
      .reverse()
      .join("");
    var node = document.createElement("div");
    var html = `
      <a class="product" href="${href}">
        <img src="${src}" alt="${alt}" />
        <div class='details'>
          <div class='title'>${title}</div>
          <div class='prices'>
            <div class="price">${price}</div>
          </div>
        </div>
      </a>
    `;
    node.innerHTML = html;
    return node.children[0];
  };
  products.forEach((product) => parent.appendChild(productNode(product)));
  container.classList.add("loaded");
}

runRefresh();
